 
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import Education from './pages/Education/Education';
import Skills from './pages/Skills/Skills';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Project from './pages/Project/Project';
import Contact from './pages/Contact/Contact'; 
import { ThemeProvider } from 'styled-components';
import Resume from './components/Resume';
import TryToFun from './pages/TryToFun/TryToFun';
// import { Cube } from './components/Comp/AllComponents';
// import SocialButtons from './components/SocialButtons/SocialButtons';

function App() {
  const theme = {
    colors:{
      heading:'rgb(24 24 29)',
      text:'rgb(24 24 29)',
      white:'#fff',
      black:'#212529',
      helper:'#8490ff',
      Bg:'rgb(249 249 255)',
      footer_bg:'#0a1435',
      btn:'rgb(98 84 243)',
      border:'rgba(98, 84, 243, 0.5)',
      hr:'#000',
      gradient:'linear-gradient(0deg, rgb(132 144 255) 0%, rgb(98 189 252)',
      shadow:'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 4px',
      shasowSupport:'rgba(0, 0, 0, 0.16 0px 1px 4px',
    },
    //for responsive
    media: {
      mobile:'768px', tab:'998px'
    },
  };

  return (
    <>
    <ThemeProvider theme={theme}>
    <Header />
     <Routes>
      <Route path='/' element={<Home />}/>
      <Route path='/education' element={<Education />}/> 
      <Route path='/skills' element={<Skills />}/>       
      <Route path='/contact' element={<Contact />}/>  
      <Route path='/project' element={  <Project /> }/>
      <Route path='/trytofun' element={  <TryToFun /> }/>
      <Route path='/resume' element={ <Resume /> }/>
    
     </Routes>
{/* <SocialButtons /> */}
{/* <Cube /> */}
     <Footer />    
     </ThemeProvider> 
   
     </>
  );
}

export default App;
